"use strict";

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _UncontrolledInput = _interopRequireDefault(require("./UncontrolledInput"));
var _Controller = _interopRequireDefault(require("../Controller"));
var _Input = _interopRequireDefault(require("./Input"));
var _proptypes = _interopRequireWildcard(require("./proptypes"));
var _excluded = ["initialValue"];
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) {
    if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
      var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
      i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
  }
  return n["default"] = e, t && t.set(e, n), n;
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
var Input = function Input(_ref) {
  var initialValue = _ref.initialValue,
    props = _objectWithoutProperties(_ref, _excluded);
  var controlled = props.onChange && (typeof initialValue === 'string' || typeof initialValue === 'number');
  if (controlled) {
    return /*#__PURE__*/_react["default"].createElement(_Controller["default"], _extends({
      initialValue: initialValue
    }, props), /*#__PURE__*/_react["default"].createElement(_Input["default"], {
      name: props.name
    }));
  }
  return /*#__PURE__*/_react["default"].createElement(_UncontrolledInput["default"], _extends({
    initialValue: initialValue
  }, props));
};
Input.propTypes = process.env.NODE_ENV !== "production" ? {
  id: _propTypes["default"].string,
  name: _propTypes["default"].string,
  initialValue: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  onChange: _propTypes["default"].func,
  onBlur: _propTypes["default"].func,
  onFocus: _propTypes["default"].func,
  placeholder: _propTypes["default"].string,
  variant: _proptypes["default"],
  fullWidth: _propTypes["default"].bool,
  error: _propTypes["default"].bool,
  multiline: _propTypes["default"].bool,
  startAdornment: _propTypes["default"].oneOfType([_propTypes["default"].element, _propTypes["default"].string, _propTypes["default"].bool]),
  endAdornment: _propTypes["default"].oneOfType([_propTypes["default"].element, _propTypes["default"].string, _propTypes["default"].bool]),
  withCounter: _propTypes["default"].bool,
  maxLength: _propTypes["default"].number,
  disabled: _propTypes["default"].bool,
  valid: _propTypes["default"].bool,
  mask: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].array, _propTypes["default"].func]),
  required: _propTypes["default"].bool,
  ariaLabel: _propTypes["default"].string
} : {};
Input.defaultProps = {
  variant: _proptypes.InputVariants.DEFAULT
};
var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(Input);